// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { Link } from "react-router-dom";
// import Pagination from "../components/pagination";

// const Suppliers = () => {
//   const [suppliers, setSuppliers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [limit] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [search, setSearch] = useState("");
//   const [status, setStatus] = useState("");
//   const [error, setError] = useState("");

//   const [paginationData, setPaginationData] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(100);
//   const [totalItems, setTotalItems] = useState(0);

//   const fetchSuppliers = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const res = await axios.get(`${apiurl}/api/supplier/get`, {
//         params: {
//           page,
//           limit: itemsPerPage,
//           search: search.trim() || undefined,
//           status: status || undefined,
//         },
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       if (res.data.success) {
//         setSuppliers(res.data.data || []);
//         setTotalPages(res.data.meta?.pages || 1);
//       } else {
//         setError("Failed to fetch suppliers");
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Server error");
//     } finally {
//       setLoading(false);
//     }
//   };

//     const handleLimitChange = (e) => {
//     setItemsPerPage(parseInt(e.target.value, 10));
//     setPage(1);
//   };

//   useEffect(() => {
//     fetchSuppliers();
//   }, [page, status, itemsPerPage]);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     setPage(1);
//     fetchSuppliers();
//   };

//   return (
//     <Layout>
//       <Container overflow={"overflow-scroll"}>
//         <div className="p-2 max-w-7xl mx-auto">
//           {/* Filters */}
//           <form
//             onSubmit={handleSearch}
//             className="flex flex-col md:flex-row gap-3 mb-4 justify-between items-center"
//           >
//             <div className="flex flex-wrap gap-2 w-full md:w-auto">
//               <input
//                 type="text"
//                 placeholder="Search suppliers..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 className="border px-4 py-2 flex-1 min-w-[200px] focus:outline-none focus:ring focus:ring-blue-200"
//               />
//               <select
//                 value={status}
//                 onChange={(e) => setStatus(e.target.value)}
//                 className="border px-4 py-2 focus:outline-none focus:ring focus:ring-blue-200"
//               >
//                 <option value="">All Status</option>
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//                 <option value="suspended">Suspended</option>
//               </select>
//               <button
//                 type="submit"
//                 className="bg-[#4B49AC] text-white px-5 py-2 hover:bg-[#3f3da3] transition"
//               >
//                 Search
//               </button>
//             </div>

//                           <div>
//                           <select
//                 className="p-2 border focus:outline-none focus:ring-2 focus:ring-[#4B49AC] mx-2"
//                 value={itemsPerPage}
//                 onChange={handleLimitChange}
//               >
//                 {[100, 200, 500, 1000].map((n) => (
//                   <option key={n} value={n}>
//                     {n}
//                   </option>
//                 ))}
//               </select>


//             <Link
//               to="/suppliers/create"
//               className="bg-[#4B49AC] text-white px-5 py-2 hover:bg-[#3f3da3] transition"
//             >
//               Add Supplier
//             </Link>
//                           </div>
//           </form>

//           {/* Error */}
//           {error && (
//             <div className="bg-red-100 text-red-700 px-4 py-2 mb-4 rounded">
//               {error}
//             </div>
//           )}

//           {/* Table */}
//           <div className="overflow-x-auto bg-white shadow rounded">
//             <table className="min-w-full text-sm text-gray-700">
//               <thead className="bg-gray-100 text-xs uppercase text-gray-600">
//                 <tr>
//                   <th className="px-4 py-3 text-left">Name</th>
//                   <th className="px-4 py-3 text-left">Contact</th>
//                   <th className="px-4 py-3 text-left">Phone</th>
//                   <th className="px-4 py-3 text-left">Tags</th>
//                   <th className="px-4 py-3 text-left">GSTIN</th>
//                   <th className="px-4 py-3 text-left">Status</th>
//                   <th className="px-4 py-3 text-center">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="6" className="text-center py-6">
//                       Loading suppliers...
//                     </td>
//                   </tr>
//                 ) : suppliers.length === 0 ? (
//                   <tr>
//                     <td colSpan="6" className="text-center py-6">
//                       No suppliers found
//                     </td>
//                   </tr>
//                 ) : (
//                   suppliers.map((supplier) => (
//                     <tr
//                       key={supplier._id}
//                       className="border-b hover:bg-gray-50 transition"
//                     >
//                       <td className="px-4 py-3 font-medium uppercase">{supplier?.name}</td>
//                       <td className="px-4 py-3">
//                         {supplier.contactPerson || "-"}
//                       </td>
//                       <td className="px-4 py-3">{supplier?.phone || "-"}</td>
//                       <td className="px-4 py-3">{supplier?.tags || "-"}</td>
//                       <td className="px-4 py-3">{supplier?.gstin || "-"}</td>
//                       <td className="px-4 py-3">
//                         <span
//                           className={`px-2 py-1 rounded text-xs font-semibold ${
//                             supplier.status === "active"
//                               ? "bg-green-100 text-green-700"
//                               : supplier?.status === "inactive"
//                               ? "bg-gray-100 text-gray-700"
//                               : "bg-yellow-100 text-yellow-700"
//                           }`}
//                         >
//                           {supplier?.status}
//                         </span>
//                       </td>
//                       <td className="px-4 py-3 text-center space-x-2">
//                         <Link
//                           to={`/suppliers/${supplier?._id}`}
//                           className="px-3 py-1 text-sm bg-[#4B49AC] text-white rounded hover:bg-[#3e3c94]"
//                         >
//                           View
//                         </Link>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//           <Pagination
//             currentPage={currentPage}
//             totalItems={totalItems}
//             itemsPerPage={itemsPerPage}
//             onPageChange={(page) => setCurrentPage(page)}
//           />
//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default Suppliers;
import React, { useEffect, useState, useCallback } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { Link } from "react-router-dom";
import Pagination from "../components/pagination";

const Suppliers = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc"); // asc or desc
  const [error, setError] = useState("");

  // Fetch suppliers
  const fetchSuppliers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const res = await axios.get(`${apiurl}/api/supplier/get`, {
        params: {
          page,
          limit: itemsPerPage,
          search: search.trim() || undefined,
          status: status || undefined,
          sortField,
          sortOrder,
        },
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      });

      if (res.data.success) {
        setSuppliers(res.data.data || []);
        setTotalItems(res.data.pagination?.totalItems || 0);
      } else {
        setError("Failed to fetch suppliers");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  }, [page, itemsPerPage, search, status, sortField, sortOrder]);

  // Fetch suppliers on mount and when dependencies change
  useEffect(() => {
    fetchSuppliers();
  }, [fetchSuppliers]);

  const handleLimitChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchSuppliers();
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-2 max-w-7xl mx-auto">
          {/* Filters */}
          <form
            onSubmit={handleSearch}
            className="flex flex-col md:flex-row gap-3 mb-4 justify-between items-center"
          >
            <div className="flex flex-wrap gap-2 w-full md:w-auto">
              <input
                type="text"
                placeholder="Search suppliers..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border px-4 py-2 flex-1 min-w-[200px] focus:outline-none focus:ring focus:ring-blue-200"
              />
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="border px-4 py-2 focus:outline-none focus:ring focus:ring-blue-200"
              >
                <option value="">All Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
                <option value="suspended">Suspended</option>
              </select>
              <button
                type="submit"
                className="bg-[#4B49AC] text-white px-5 py-2 hover:bg-[#3f3da3] transition"
              >
                Search
              </button>
            </div>

            <div className="flex items-center">
              <select
                className="p-2 border focus:outline-none focus:ring-2 focus:ring-[#4B49AC] mx-2"
                value={itemsPerPage}
                onChange={handleLimitChange}
              >
                {[100, 200, 500, 1000].map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </select>

              <Link
                to="/suppliers/create"
                className="bg-[#4B49AC] text-white px-5 py-2 hover:bg-[#3f3da3] transition"
              >
                Add Supplier
              </Link>
            </div>
          </form>

          {/* Error */}
          {error && (
            <div className="bg-red-100 text-red-700 px-4 py-2 mb-4 rounded">
              {error}
            </div>
          )}

          {/* Table */}
          <div className="overflow-x-auto bg-white shadow rounded">
            <table className="min-w-full text-sm text-gray-700">
              <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                <tr>
                  {["name", "contactPerson", "phone", "tags", "gstin", "status"].map(
                    (field) => (
                      <th
                        key={field}
                        className="px-4 py-3 text-left cursor-pointer"
                        onClick={() => handleSort(field)}
                      >
                        {field.toUpperCase()}
                        {sortField === field && (
                          <span>{sortOrder === "asc" ? " ↑" : " ↓"}</span>
                        )}
                      </th>
                    )
                  )}
                  <th className="px-4 py-3 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-6">
                      Loading suppliers...
                    </td>
                  </tr>
                ) : suppliers.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-6">
                      No suppliers found
                    </td>
                  </tr>
                ) : (
                  suppliers.map((supplier) => (
                    <tr
                      key={supplier._id}
                      className="border-b hover:bg-gray-50 transition"
                    >
                      <td className="px-4 py-3 font-medium uppercase">{supplier?.name}</td>
                      <td className="px-4 py-3">{supplier.contactPerson || "-"}</td>
                      <td className="px-4 py-3">{supplier?.phone || "-"}</td>
                      <td className="px-4 py-3">{supplier?.tags || "-"}</td>
                      <td className="px-4 py-3">{supplier?.gstin || "-"}</td>
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded text-xs font-semibold ${
                            supplier.status === "active"
                              ? "bg-green-100 text-green-700"
                              : supplier?.status === "inactive"
                              ? "bg-gray-100 text-gray-700"
                              : "bg-yellow-100 text-yellow-700"
                          }`}
                        >
                          {supplier?.status}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-center space-x-2">
                        <Link
                          to={`/suppliers/${supplier?._id}`}
                          className="px-3 py-1 text-sm bg-[#4B49AC] text-white rounded hover:bg-[#3e3c94]"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <Pagination
            currentPage={page}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </div>
      </Container>
    </Layout>
  );
};

export default Suppliers;